import { useState } from 'react'
import useOnInit from '../../../../BatchProposal/hook/useOnInit'

import _ from 'lodash'
import { Button, Toast } from '@vzmi/shp_shared_compo'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import Tip from '../../../Common/Tip'
import {
  FormRow,
  MassiveMenuSelectField,
  When
} from '../../../../Common/Form'
import { Field } from '../../../../Common/forms'
import SingleLineText from '../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { safeAwait, httpHandler } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { getNoticeAndBrandId, BRAND_ID_ERROR_NOTICE } from '../../helper'
import styles from './index.css'
import { validateRequiredUpdateListingBrandId } from '../../../../Proposal/Common/ProposalForm/Shared/validation/fieldLevelValidator'

const brandIdConnectField = 'brandId'
const brandNameConnectField = 'brandName'

const BrandIDInfo = props => {
  const {
    readOnly,
    fetchBrands,
    triggerFieldChange,
    listing,
    flags
  } = props
  const [options, setOptions] = useState([])

  // load brand options on mount
  useOnInit(() => {
    if (readOnly) {
      return
    }
    const fetchData = async () => {
      const [error, payload] = await safeAwait(
        fetchBrands().then(httpHandler)
      )
      if (error) {
        Toast.error(BRAND_ID_ERROR_NOTICE.REFRESH_PAGE)
        return
      }
      // make every item in the array an object with value and label replaced with name and id
      const brands = _.get(payload, 'brands', [])
      setOptions(brands.map(brand => ({
        value: brand.id,
        label: brand.name
      })))
    }
    fetchData()
  })

  const alginWithSpecTable = () => {
    const {
      notice,
      brandId,
      isErrorNotice
    } = getNoticeAndBrandId(listing, options)

    if (isErrorNotice) {
      Toast.error(notice)
      return
    }

    if (notice) {
      Toast.warn(notice)
    }

    triggerFieldChange(brandIdConnectField, brandId)
  }

  const brandIdRequiredToggle = getFeatureToggle(flags, 'sp_brand_be')

  const brandIdValidation = (value) => {
    if (!brandIdRequiredToggle) {
      return null
    }

    return validateRequiredUpdateListingBrandId(value)
  }

  return (
    <div>
      <FormRow
        label='商品品牌'
      >
        <Tip
          type='subTitle'
          className={styles.tip}
        >
          幫助更多用戶透過品牌找到您的商品
        </Tip>
        <div className={styles.flexContainer}>
          <div className={styles.flexItem}>
            <Field
              key='brandId'
              name={readOnly ? brandNameConnectField : brandIdConnectField}
              component={readOnly ? SingleLineText : MassiveMenuSelectField}
              data-role='product-brandId'
              options={options}
              showErrorOnActive
              mustShowFormError
              validate={brandIdValidation}
            />
          </div>
          <When
            value={!readOnly}
            isTrue
          >
            <div className={styles.flexItem}>
              <Button
                data-role='align-brandId-withSpecTable-button'
                className={styles.alginBrandIdButton}
                onClick={alginWithSpecTable}
              >
                同規格表品牌欄位
              </Button>
            </div>
          </When>
        </div>
      </FormRow>
    </div>
  )
}

export default BrandIDInfo
